module.exports = __webpack_public_path__ + "img/更智能.2da2ff8f.png";